import * as React from "react";

import { cn } from "utils/cn";

interface SectionProps {
  title: string;
  description?: React.ReactNode;
  /** Shown to the right of the title, e.g. a status badge or a button. */
  aside?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

/** One block of the profile drawer: a heading row, then its content. */
const Section: React.FC<SectionProps> = ({ title, description, aside, className, children }) => (
  <section aria-label={title} className={cn("space-y-4", className)}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 space-y-1">
        <h3 className="text-sm font-semibold text-foreground">{title}</h3>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {aside && <div className="flex shrink-0 items-center gap-2">{aside}</div>}
    </div>
    {children}
  </section>
);

export default Section;
